module.exports = __webpack_public_path__ + "img/img_12.ddd6061a.jpg";